export function attachCloudFileChange($context) {
    if (!$context.length) {
        return;
    }

    $context.on('click', ".triggerUpload", function (event) {
        event.preventDefault();

        $(this).closest('.stimuliAdditionalData').find('.cloud-component-upload label').click();
    });

    $context.on('click', ".triggerGetFromCloud", function (event) {
        event.preventDefault();

        $(this).closest('.stimuliAdditionalData').find('.cloud-component-popup button').click();
    });
}
